import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
    let { language, rewardlist } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  render() {
    let { language, lang, nav2, rewardlist } = this.props
    // console.log(111111111, rewardlist[0])
    return (
      <div className="prize">
        {rewardlist[0] && rewardlist[0].length>5 && 
        <div className="r1">
          <div className="head">  
            Top 1        
          </div>
          {rewardlist[0][0] && <div className="rw0"> 
            <img src={rewardlist[0][0].image_url}/>
            <div className="txt">    
            {rewardlist[0][0].name}
            </div>
          </div>}
          {rewardlist[0][1] && <div className="rw1">  
          <img src={rewardlist[0][1].image_url}/>
            <div className="txt">    
            {rewardlist[0][1].name}   
            </div>        
          </div>
  }
          {rewardlist[0][2] && <div className="rr rw2">  
          <img src={rewardlist[0][2].image_url}/>
            <div className="txt">    
            {rewardlist[0][2].name}  
            </div>        
          </div>}
          {rewardlist[0][3] && <div className="ww rw3">  
          <img src={rewardlist[0][3].image_url}/>
            <div className="txt">    
            {rewardlist[0][3].name}   
            </div>        
          </div>}
          {rewardlist[0][4] && <div className="rr rw4">  
          <img src={rewardlist[0][4].image_url}/>
            <div className="txt">    
            {rewardlist[0][4].name} 
            </div>        
          </div>}
          {rewardlist[0][5] && <div className="ww rw5">  
          <img src={rewardlist[0][5].image_url}/>
            <div className="txt">    
            {rewardlist[0][5].name}  
            </div>        
          </div>}
          {rewardlist[0][6] && <div className="rr rw6">  
          <img src={rewardlist[0][6].image_url}/>
            <div className="txt">    
            {rewardlist[0][6].name}
            </div>        
          </div>}
          {rewardlist[0][7] && <div className="ww rw7">  
          <img src={rewardlist[0][7].image_url}/>
            <div className="txt">    
            {rewardlist[0][7].name}
            </div>        
          </div>}
        </div>
        }
        {rewardlist[0] && rewardlist[0].length<=5 && 
        <div className="r2">
        <div className="head">
        Top 1
        </div>
        <div className="allreward">
        {rewardlist[0] &&
                rewardlist[0].length <=5 &&
                rewardlist[0].map((item, index) => {
                  // console.log(111, item)
                  // if (index > 2) {
                    return (
                      <div className="rr">  
          <img src={rewardlist[0][index].image_url}/>
          <div className="txt">    
          {language == 'ar' ? rewardlist[0][index].name_tr:rewardlist[0][index].name}     
          </div>        
        </div>
                    )
                  // }
                })}

                </div>


        </div>
        }
{rewardlist[1] && rewardlist[1].length>=1 && 
        <div className="r2">
        <div className="head">
        Top 2
        </div>
        <div className="allreward">
        {rewardlist[1] &&
                rewardlist[1].length > 0 &&
                rewardlist[1].map((item, index) => {
                  // console.log(111, item)
                  // if (index > 2) {
                    return (
                      <div className="rr">  
          <img src={rewardlist[1][index].image_url}/>
          <div className="txt">    
          {language == 'ar' ? rewardlist[1][index].name_tr:rewardlist[1][index].name}     
          </div>        
        </div>
                    )
                  // }
                })}

                </div>


        </div>
        }

{rewardlist[2] && rewardlist[2].length>=1 && 
        <div className="r2">
        <div className="head">
        Top 3
        </div>
        <div className="allreward">
        {rewardlist[2] &&
                rewardlist[2].length > 0 &&
                rewardlist[2].map((item, index) => {
                  // console.log(111, item)
                  // if (index > 2) {
                    return (
                      <div className="rr">  
          <img src={rewardlist[2][index].image_url}/>
          <div className="txt">    
          {language == 'ar' ? rewardlist[2][index].name_tr:rewardlist[2][index].name}     
          </div>        
        </div>
                    )
                  // }
                })}

                </div>


        </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/202408tr/Prize/index.js